import { eventChannel, SagaIterator } from 'redux-saga';
import { all, call, fork, put, race, take, cancel } from 'redux-saga/effects';
import { RANGER_CONNECT_DATA, RANGER_CONNECT_FETCH, RANGER_DISCONNECT_DATA, RANGER_DISCONNECT_FETCH } from '../constants';
import { rangerDisconnectFetch, rangerDisconnectData } from '../actions';
import { appUrls } from '../../../../api-new/urls';
import { setCurrentPrice } from '../../price-board/actions';

const initRanger = (baseUrl: string, withAuth: boolean, symbol: string) => {
    const wsUrl = `${baseUrl}?withAuth=${withAuth}&symbol=${symbol}`;
    const ws = new WebSocket(wsUrl);
    const channel = eventChannel((emitter) => {
        ws.onopen = () => {
            // console.log('WebSocket connected');
            if (ws.readyState === WebSocket.OPEN) {
                ws.send(JSON.stringify({ type: 'subscribe', symbol }));
                // console.log('Message sent symbol successfully');
            } else {
                // console.log('WebSocket not ready');
            }
            emitter({ type: RANGER_CONNECT_DATA });
        };
        ws.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data); // Phân tích dữ liệu JSON
        
                // Kiểm tra dữ liệu trả về từ máy chủ
                if (data.status === "subscribed") {
                    // console.log(`Subscribed to symbol: ${data.symbol}`);
                } else if (data.error) {
                    console.error("Error from server:", data.error);
                } else {
                    // console.log("Received message:", data);
                    emitter(setCurrentPrice(data.intraday_data[0].price));
                }
            } catch (error) {
                console.error("Failed to parse message:", event.data);
            }
        };
        ws.onclose = () => {
            emitter(rangerDisconnectData());
            channel.close();
        };
        ws.onerror = (error) => {
            console.error('WebSocket error:', error);
        };

        return () => {
            ws.close();
        };
    });

    return [channel, ws];
};

function* watchDisconnect(socket: any) {
    yield take(RANGER_DISCONNECT_FETCH);
    socket.close();
}

function* bindSocket(channel: any, socket: any): SagaIterator {
    yield all([
        call(function* reader(): SagaIterator {
            while (true) {
                const action = yield take(channel);
                yield put(action);
            }
        }),
        call(watchDisconnect, socket),
    ]);
}

export function* rangerSagas(): SagaIterator {
    let initialized = false;
    let pipes;

    while (true) {
        const { connectFetch, disconnectData } = yield race({
            connectFetch: take(RANGER_CONNECT_FETCH),
            disconnectData: take(RANGER_DISCONNECT_DATA),
        });

        if (disconnectData) {
            yield call(() => new Promise((resolve) => setTimeout(resolve, 1000)));
        }
       

        if (connectFetch) {
            if (initialized) {
                yield put(rangerDisconnectFetch());
                yield take(RANGER_DISCONNECT_DATA);
            }

            const { withAuth, symbol } = connectFetch.payload;
            const [channel, socket] = yield call(initRanger, appUrls.socketDataURL, withAuth, symbol);
            initialized = true;

            if (pipes) {
                yield cancel(pipes);
            }

            pipes = yield fork(bindSocket, channel, socket);
        }
    }
}
